import React from "react";
import { DatePicker } from 'antd';
import moment, { Moment } from "moment";
const { RangePicker } = DatePicker;

type DateRangePickerProps = {
    startDate: Moment;
    endDate: Moment;
    onChange: (startDate: Moment, endDate: Moment) => void;
    style?: React.CSSProperties;
};

const DateRangePicker: React.FunctionComponent<DateRangePickerProps> = ({
    startDate,
    endDate,
    onChange,
    style
}) => {
    const endHour = { hour: 23, minute: 59, second: 59, millisecond: 0 }

    const disabledFutureDate = (current: any) => {
        return current && current > moment().endOf('day');
    }
    
    const onIntervalChange = (values: any) => {
        const startDate = (values[0] as Moment).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
        const endDate = (values[1] as Moment).set(endHour);
        onChange(startDate, endDate);
    }

    return <RangePicker defaultValue={[startDate, endDate]} disabledDate={disabledFutureDate} onChange={onIntervalChange} style={style} />
};

export default DateRangePicker; 